var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4017 6.26368C12.4017 9.72302 9.62551 12.5274 6.20087 12.5274C2.77622 12.5274 0 9.72302 0 6.26368C0 2.80435 2.77622 0 6.20087 0C9.62551 0 12.4017 2.80435 12.4017 6.26368ZM1.73564 6.26368C1.73564 8.75474 3.73479 10.7741 6.20087 10.7741C8.66694 10.7741 10.6661 8.75474 10.6661 6.26368C10.6661 3.77262 8.66694 1.75322 6.20087 1.75322C3.73479 1.75322 1.73564 3.77262 1.73564 6.26368Z",
    fill: "#E5E4E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.55772,
    height: 1.97878,
    transform: "matrix(0.708727 0.705483 -0.610497 0.792019 9.93457 9.39648)",
    fill: "#E5E4E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.70ecfa2ac4daf5da5583c88a3456b362.svg";
export { ForwardRef as ReactComponent };